import React from 'react';
import { styleIcon } from '../style_icon.js';
export function CaretLeftIcon({ title = 'Caret Left Icon', ...rest }) {
    const style = styleIcon(rest);
    return (React.createElement("svg", { ...style, viewBox: "0 0 8 12" },
        !style['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M5.58599 0.646521L0.586071 5.64644C0.390811 5.8417 0.390811 6.15828 0.586071 6.35355L5.58599 11.3535C5.78125 11.5487 6.09783 11.5487 6.2931 11.3535L7.00006 10.6465C7.19532 10.4513 7.19532 10.1347 7.00006 9.9394L3.06064 5.99998L7.00006 2.06056C7.19532 1.8653 7.19532 1.54872 7.00006 1.35345L6.2931 0.646491C6.09784 0.451231 5.78126 0.451261 5.58599 0.646521Z" })));
}
//# sourceMappingURL=caret_left_icon.js.map